import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { useLang } from "../LanguageContext";
import { safeGetItem, safeSetItem } from "../lib/storage";

export const CookieConsent = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = safeGetItem("skystart_cookie_consent");
    if (!v) setShow(true);
  }, []);

  const decide = (accepted) => {
    safeSetItem("skystart_cookie_consent", accepted ? "accepted" : "declined");
    setShow(false);
    if (accepted && typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-black/90 backdrop-blur-xl border-t border-white/10 px-5 py-5"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="text-[#E02020] shrink-0 mt-0.5" size={22} />
          <p className="text-sm text-white/80 max-w-2xl leading-relaxed">{t.cookie.text}</p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={() => decide(false)}
            className="px-5 py-2.5 text-sm border border-white/20 text-white rounded-sm hover:bg-white/10 transition-colors"
          >
            {t.cookie.decline}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide(true)}
            className="px-5 py-2.5 text-sm bg-[#E02020] hover:bg-[#B91818] text-white rounded-sm transition-colors"
          >
            {t.cookie.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
